import { ComponentStyleConfig } from '@chakra-ui/react';

export const Popover: ComponentStyleConfig = {
  baseStyle: {
    popper: {
      outline: 'unset !important',
    },
    content: {
      outline: 'unset !important',
      boxShadow: 'elevated',
      _focusVisible: {
        boxShadow: 'elevated',
      },
    },
  },
  variants: {},
  sizes: {},
  defaultProps: {},
  parts: [],
};
